var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBaoCao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#FF003D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 16.9636L17.8573 9.07529C17.8573 8.88504 17.7814 8.70216 17.6433 8.56519C17.3878 8.31191 16.9613 7.89516 16.6898 7.66295C16.3433 7.36666 15.9839 7.01524 15.7569 6.787C15.6059 6.63513 15.3973 6.54688 15.1781 6.54688H9.29508M17.8571 16.9636C17.8571 17.7854 17.1601 18.4516 16.3004 18.4516L9.29501 18.4516C8.43525 18.4516 7.73828 17.7854 7.73828 16.9635L7.73834 8.03496C7.73835 7.21311 8.43532 6.54688 9.29508 6.54688M17.8571 16.9636L17.8573 9.52307M9.29508 6.54688H14.7439M15.4764 15.4754V13.2929M12.7978 15.4754L12.7978 8.92783M10.1192 15.4754L10.1192 8.92783",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBaoCao);
export default __webpack_public_path__ + "static/media/icon_bao_cao.0ded79bf2162282ace3d69bd733d02ff.svg";
export { ForwardRef as ReactComponent };